import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams, HttpResponse, HttpRequest } from '@angular/common/http';
import { Observable, of, Subject } from 'rxjs';
import { get as _get } from 'lodash';
import { Seeker } from '@app-models/index';
import { APIs } from '@app-settings/index';
import { HttpHeaderService } from '@app-services/http-header.service';
@Injectable()
export class SeekersService {
	closeCoversationSubject = new Subject<string>();
	constructor(
		private _httpClient: HttpClient,
		private _httpHeaderService: HttpHeaderService,
	) {
	}
	getoms(searchvalue, value = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let dis = 'Discipler'
		let params: HttpParams = new HttpParams;
		params = params.set('searchvalue', `${searchvalue}`);
		//let user_uuid_id=this.res.user_uuid
		if (searchvalue) {
			return this._httpClient.get(`${APIs.oms}?${value}=${searchvalue}&level_like=${dis}`, { params: params, headers: headers });
		}
	}
	getcrmusers(searchvalue, value = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		//let dis = 'Discipler'
		let params: HttpParams = new HttpParams;
		params = params.set('searchvalue', `${searchvalue}`);
		//let user_uuid_id=this.res.user_uuid
		if (searchvalue) {
			return this._httpClient.get(`${APIs.crmusers}?${value}=${searchvalue}`, { params: params, headers: headers });
		}
	}
	getabusiveconversation() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.abusive}/getabusive-conversation`, { headers: headers });
	}
	insertabusive(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.abusive}/insertabusive-conversation`, body, { headers: headers });
	}
	updateabusive(body: any, uuid) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(`${APIs.abusive}/${uuid}/updateabusive-conversation`, body, { headers: headers });
	}
	updateclose(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(`${APIs.conversations}/updateisunresponded/`, body, { headers: headers });
	}
	updateabusiveblock(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(`${APIs.abusive}/block-conversation`, body, { headers: headers });
	}
	updateabusiveprevious(uuid) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(`${APIs.abusive}/${uuid}/updateabusive-previous`, { headers: headers });
	}
	getListNotifications() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.notification}/`, { params: { type: 'A' }, headers: headers });
	}
	getSeekers(uuid: string = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.seekers;
		if (uuid)
			api += '/' + uuid;
		return this._httpClient.get(api, { headers: headers });
	}
	getSeeker(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.seekers}/${uuid}`, { headers: headers });
	}
	addSeekerTimeline(uuid: string, data: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.seekers}/${uuid}/timeline`, data, { headers: headers });
	}
	getSeekerTimeline(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.seekers}/${uuid}/timeline`, { headers: headers });
	}
	getSeekerDetails(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.seekers}/${uuid}`, { headers: headers });
	}
	removeSeekerTag(uuid: string, value: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(`${APIs.seekers}/remove_tag/${uuid}`, { value: value }, { headers: headers });
	}
	getSeekerTestimonies(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.seekers}/${uuid}/testimonies`, { headers: headers });
	}
	updateSeekers(body: Seeker, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.put(`${APIs.seekers}/${uuid}`, body, { headers: headers });
	}
	deleteSeekers(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		return this._httpClient.delete(`${APIs.seekers}/${uuid}`, { headers: headers });
	}
	deleteSeekerTimeline(seeker_uuid: string, timeline_uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !seeker_uuid)
			return of(null);
		return this._httpClient.delete(`${APIs.stories}/${seeker_uuid}/timeline/${timeline_uuid}`, { headers: headers });
	}
	deleteSeekerTestimonies(seeker_uuid: string, testimony_uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !seeker_uuid)
			return of(null);
		return this._httpClient.delete(`${APIs.stories}/${seeker_uuid}/testimonies/${testimony_uuid}`, { headers: headers });
	}
	getStories(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.stories}`, { headers: headers });
	}
	deleteStories(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		return this._httpClient.delete(`${APIs.stories}/${uuid}`, { headers: headers });
	}
	getSeekersPool(uuid: string = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.seekers_pool;
		if (uuid)
			api += '/' + uuid;
		return this._httpClient.get(api, { headers: headers });
	}
	assignSeeker(conversation_uuid: string, om_uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.seekers}/${conversation_uuid}/assign/${om_uuid}`, { headers: headers });
	}
	assignMultipleSeeker(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.seekers}/multi_assign`, body, { headers: headers });
	}
	getCountries() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.crm_settings}/countries`, { headers: headers });
	}
	getLanguages() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.get(`${APIs.crm_languages}`, { headers: headers });
	}
	getProfileControls() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.seekers + '/profile-controls'
		return this._httpClient.get(`${api}`, { headers: headers });
	}
	updateSeekerProfileControl(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.seekers + '/profile-controls'
		return this._httpClient.post(`${api}`, body, { headers: headers });
	}
	getConversationCategories(uuid = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.conversation_categories;
		if (uuid) {
			return this._httpClient.get(`${api}/${uuid}`, { headers: headers });
		} else {
			return this._httpClient.get(`${api}`, { headers: headers });
		}
	}
	getOverflowCategories(uuid = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.overflow_categories ;
		if (uuid) {
			return this._httpClient.get(`${api}/${uuid}`, { headers: headers });
		} else {
			return this._httpClient.get(`${api}`, { headers: headers });
		}
	}
	getSourcesItems(uuid = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.conversation_categories;
		return this._httpClient.get(`${api}/${uuid}`, { headers: headers });
	}

	getConversationCategorieswithlang(id) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.conversation_categories;

		return this._httpClient.get(`${api}?language_id=${id}`, { headers: headers });

	}
	getConversationCategoriescommunity(id) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.conversation_categories;
		return this._httpClient.get(`${api}/category_exist?language_id=${id}`, { headers: headers });
	}
	getConversationCategoriesdetails(uuid = null) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.conversation_categories;
		if (uuid) {
			return this._httpClient.get(`${api}/${uuid}/details`, { headers: headers });
		} else {
			return this._httpClient.get(`${api}`, { headers: headers });
		}
	}
	getCategoriesApprovals() {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.conversation_categories + '/get_approvals';
		return this._httpClient.get(`${api}`, { headers: headers });
	}
	storeConversationCategories(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(APIs.conversation_categories, body, { headers: headers });
	}
	updateConversationCategories(body: any, uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.conversation_categories}/${uuid}`, body, { headers: headers });
	}
	updateConversationCategoriesApproval(selectedItem: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.conversation_categories}/get_approvals/${selectedItem.uuid}`, {}, { headers: headers });
	}
	deleteConversationCategory(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		return this._httpClient.delete(`${APIs.conversation_categories}/${uuid}`, { headers: headers });
	}
	deleteConversationCategoryApproval(uuid: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers || !uuid)
			return of(null);
		return this._httpClient.delete(`${APIs.conversation_categories}/delete_approvals/${uuid}`, { headers: headers });
	}
	assignConversationCategory(body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		return this._httpClient.post(`${APIs.conversation_categories}/multi_assign`, body, { headers: headers });
	}
	getSeekerConversations(seekerUUID: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.seekers + '/get_seekers_conversations/' + seekerUUID;
		return this._httpClient.get(`${api}`, { headers: headers });
	}
	getMessages(conversationUUID: string, user_uuid, seeker_uuid, crm_user) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.seekers + '/get_seekers_conversations/' + conversationUUID + '/messages/' + user_uuid + '/' + seeker_uuid + '/' + crm_user;
		return this._httpClient.get(api, { headers: headers });
	}
	sendMessage(conversationUUID: string, body: any) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.seekers + '/send_message/' + conversationUUID;
		return this._httpClient.post(`${api}`, body, { headers: headers });
	}
	getSeekerConversationsPreferences(seekerUUID: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.seekers + '/get_seekers_conversations_preferences/' + seekerUUID;
		return this._httpClient.get(`${api}`, { headers: headers });
	}
	getPool(scope: string) {
		const headers = this._httpHeaderService.getHttpHeader();
		if (!headers)
			return of(null);
		let api = APIs.conversations + '/getPool';
		return this._httpClient.get(`${api}`, { headers: headers });
	}
}
